module.exports = {
	"shared.crew.original-music-composer": "Musikk",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publisist",
	"share-overlay.share": "Del denne videoen",
	"shared.crew.associate-producer": "Assisterende produsent",
	"shared.crew.assistant-editor": "Assisterende redaktør",
	"overlay.buy-from": "Kjøp fra {price}",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Ekstra fotografi",
	"shared.crew.sound-editor": "Lydredigering",
	"shared.crew.print-shipper": "Print shipper",
	"shared.crew.hairstylist": "Hårstylist",
	"shared.crew.makeup-effects": "Makeup effekter",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Assisterende produsent",
	"shared.crew.executive-producer": "Exekutiv produsent",
	"shared.crew.costumer": "Kostymør",
	"info-overlay.cast": "Medvirkende",
	"shared.crew.stunt-coordinator": "Stuntkoordinator",
	"shared.crew.academic-advisor": "Akademisk rådgiver",
	"shared.crew.swing-gang": "Swing gang",
	"shared.crew.best-boy": "Best boy",
	"actions.purchased": "Du eier denne videoen",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Scenedekoratør",
	"shared.crew.adaptation": "Adaptation",
	"shared.crew.school-administrator": "Skoledirektør",
	"shared.crew.cable-person": "Kabelperson",
	"shared.crew.digital-effects": "Digitale effekter",
	"actions.rent": "Leie {price}",
	"info-overlay.created-by": "Av {author}",
	"social-share.twitter": "Se \"{title}\" på {siteUrl}",
	"shared.crew.production-designer": "Produksjonsdesigner",
	"info-overlay.crew": "team",
	"shared.crew.producer": "Produsent",
	"shared.crew.2nd-unit-dir-of-photography": "2. team sjefsfotograf",
	"shared.crew.special-effects": "Spesialeffekter",
	"actions.rented": "Leies inntil {date}",
	"shared.crew.boom-operator": "Boomer",
	"shared.crew.story": "Historie",
	"shared.crew.script-supervisor": "Script supervisor",
	"shared.crew.director": "Regissør",
	"shared.crew.choreographer": "Koreograf",
	"shared.crew.production-manager": "Produksjonssjef",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Leadperson",
	"shared.crew.location-manager": "Locationmanager",
	"shared.crew.costume-designer": "Kostymedesigner",
	"fullscreen.exit": "Avslutt fullskjerm",
	"shared.crew.technical-advisor": "Teknisk rådgiver",
	"shared.crew.editor": "Redigering",
	"shared.crew.additional-grip": "Ekstra grip",
	"actions.buy": "Kjøpe {price}",
	"shared.crew.assistant-camera": "Assisterende kameramann",
	"shared.crew.writer": "Manus",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Samarbeidene direktør",
	"fullscreen.enter": "Full skjerm",
	"shared.crew.animal-trainer": "Dyretrener",
	"shared.crew.assistant-art-director": "Assisterende art director",
	"shared.crew.key-grip": "Key grip",
	"social-button.copy": "Kopier",
	"shared.crew.makeup-artist": "Makeup artist",
	"overlay.source-error": "Videoer kan ikke spilles",
	"social-button.link": "Link",
	"actions.buy-from": "Kjøp fra {price}",
	"shared.crew.art-director": "Art director",
	"shared.crew.production-coordinator": "Produksjonskoordinator",
	"shared.crew.co-director": "Co-direktør",
	"shared.crew.co-producer": "Co-produsent",
	"shared.crew.video-operator": "Videooperatør",
	"shared.crew.camera-operator": "Kameramann",
	"shared.crew.co-writer": "Co-skribent",
	"shared.crew.set-designer": "Scenograf",
	"shared.crew.preview-return": "Preview return",
	"shared.crew.property-master": "Rekvisitør",
	"shared.crew.cinematographer-dp": "Filmfotograf / DP",
	"shared.crew.grip": "Grip",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Lydteknikker",
	"quality.label": "Kvalitet",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Gaffer",
	"shared.crew.assistant-director": "Regiassistent",
	"actions.subscribe": "Abonner {price}/måned",
	"shared.crew.print-return": "Print return",
	"shared.crew.animator": "Animator",
	"shared.crew.dolly-grip": "Dolly",
	"shared.crew.manager": "Manager",
	"shared.crew.2nd-assistant-director": "2. regiassistent",
	"shared.crew.author-of-adapted-material": "Forfatter av tilpasset materiale"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_no.json
// module id = 1445
// module chunks = 0 1 2 3